import { useCallback, useRef, useState } from "react";
import { Badge, Form, Table } from "react-bootstrap";
import ToolBar from "../Componant/ToolBar";
import { inboxServices } from "../../APIServices/SitePilotManagement/inboxServices";
import InboxDetails from "./InboxDetails";
import { useEffect } from "react";
import Moment from "react-moment";
import Swal from "sweetalert2";
import { ChatSocket } from "../../APIServices/GoServerApi/chatService";
import { useLiveDuration } from "../../Hooks/DurationHook";
import { formatDuration, limitText } from "../../APIHelpers/utils";

const InboxData = ({ category, currentUserData, openModule }) => {
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [inboxs, setInboxs] = useState([]);
  const [inboxData, setInboxData] = useState("");
  const [inboxId, setInboxId] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [inboxType, setInboxType] = useState("");
  const [inboxCount, setInboxCount] = useState(0);
  const [inboxIds, setInboxIds] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [hoverId, setHoverId] = useState(null);

  const toggleSingle = (inboxId, sessionId) => {
    setInboxIds((prev) => {
      const exists = prev.some(
        (item) =>
          item?.inboxId === inboxId &&
          item?.sessionId === sessionId
      );
      if (exists) {
        return prev.filter(
          (item) =>
            !(
              item?.inboxId === inboxId &&
              item?.sessionId === sessionId
            )
        );
      }
      return [...prev, { inboxId, sessionId }];
    });
  };

  const toggleAll = () => {
    if (inboxIds?.length === inboxs?.length) {
      setInboxIds([]);
    } else {
      setInboxIds(
        inboxs?.map((c) => ({
          inboxId: c.inboxId,
          sessionId: c.sessionId,
        }))
      );
    }
  };

  const isAllChecked =
    inboxs?.length > 0 && inboxIds?.length === inboxs?.length;

  const isChecked = (inboxId, sessionId) =>
    inboxIds?.some(
      (item) =>
        item?.inboxId === inboxId &&
        item?.sessionId === sessionId
    );

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(inboxCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, inboxCount);

  const getInboxList = async () => {
    setLoader(true);
    let data = await inboxServices.getInboxList(
      inboxType || "liveChat",
      category,
      search,
      pageNumber,
      itemsPerPage,
    );
    setInboxs(data?.data || []);
    setInboxCount(data?.count || 0);
    setLoader(false);
  };

  useEffect(() => {
    if (inboxType) {
      getInboxList();
    }
  }, [inboxType, search, pageNumber, itemsPerPage]);

  useEffect(() => {
    if (category === "visitor") {
      setInboxType("liveChat")
    } else {
      setInboxType("all")
    }
  }, [category]);
  const wsRef = useRef(null);

  const updateInboxList = useCallback(async (inboxId, sessionId) => {
    const inbox = await inboxServices.getSingleInbox(inboxId, sessionId);
    const inboxData = inbox?.data;
    if (!inboxData || !inboxData._id || !inboxData.inboxId || !inboxData.sessionId) {
      return;
    }
    const messages = inboxData?.messages || [];
    const onlyMessages = messages.filter((m) => m.type === "message");
    const notifications = messages.filter((m) => m.type !== "message");
    const lastMessage = onlyMessages[onlyMessages.length - 1];

    const newObj = {
      ...inboxData,
      totalNotification: notifications.length,
      totalMessage: onlyMessages.length,
      lastMessage: lastMessage?.message || "",
      lastRepliedBy: lastMessage?.userType || "",
      lastReplaiedDT: lastMessage?.createdAt || "",
      chatStatus: inboxData?.chatStatus ?? "",
      sessionStatus: inboxData?.sessionStatus ?? "",
      updatedAt: inboxData?.updatedAt ?? new Date(),
    };

    setInboxs((prev) => {
      const index = prev.findIndex(
        (item) =>
          item.inboxId === inboxId &&
          item.sessionId === sessionId
      );

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          ...newObj,
        };
        return updated;
      }

      return [...prev, newObj];
    });
  }, []);

  const updateInboxListRef = useRef(updateInboxList);

  useEffect(() => {
    updateInboxListRef.current = updateInboxList;
  }, [updateInboxList]);

  useEffect(() => {
    if (openModule === "inbox" || openModule === "monitoring" || openModule === "activeChats") {
      getInboxList()
    }
    const sock = new ChatSocket({
      userId: "admin",
      name: "admin",
      autoReconnect: true,
      onError: (e) => console.log("ADMIN WS ERROR", e),
      onOpen: () => console.log("ADMIN WS OPEN"),
      onEvent: (type, data) => {
        if ((openModule === "inbox" || openModule === "monitoring" || openModule === "activeChats") && (type === "visitor:opened" || type === "message:new") && data?.visitorId) {
          updateInboxListRef.current(data.visitorId, data.sessionId);
        }
      },
    });

    sock.connect();
    wsRef.current = sock;
    return () => sock.disconnect();
  }, []);

  const emitTypingPreview = () => {
    const uniqueId = `${inboxData?.inboxId}_${inboxData?.sessionId}`;
    if (!uniqueId) return;
    wsRef.current.sendRoomAlertReceived({
      uniqueId,
      message: "Hello World",
    });
  };

  useEffect(() => {
    if (!wsRef.current) return;
    wsRef.current.onEvent = (type, data) => {
      // console.log(">>type", type);
      // console.log(">>data", data);
    };
  }, []);
  useEffect(() => {
    emitTypingPreview()
  }, [wsRef]);

  const softDeleteRestoreInbox = async (type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${type} this selected item?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.type = type
        userData.inboxIds = inboxIds
        let data = await inboxServices.softDeleteRestoreInbox(userData)
        if (data?.statusCode === 200) {
          getInboxList()
          setInboxIds([])
        }
      }
    });
  };

  const deleteInbox = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to permanent delete this selected item?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.inboxIds = inboxIds
        let data = await inboxServices.deleteInbox(userData)
        if (data?.statusCode === 200) {
          getInboxList()
          setInboxIds([])
        }
      }
    });
  };

  const deleteSession = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to permanent delete this session?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.inboxId = inboxData?.inboxId
        userData.sessionId = inboxData?.sessionId
        let data = await inboxServices.deleteSession(userData)
        setInboxData("");
        setInboxId("");
        setSessionId("");
        setShowPreview(false);
      }
    });
  };

  const InboxRow = ({ key, item }) => {
    const liveDuration = useLiveDuration(item?.startedDT, !(item?.chatStatus === "closed" || item?.sessionStatus === "closed"));
    return (
      <tr
        key={key}
        className={`inbox-row ${(inboxData?.inboxId === item?.inboxId && inboxData?.sessionId === item?.sessionId) ? "active" : ""
          }`}
        onClick={() => {
          setInboxData(item);
          setInboxId(item?.inboxId);
          setSessionId(item?.sessionId);
          setShowPreview(true);
        }}
      >
        <td>
          <div
            className="d-flex align-items-center gap-2"
            onMouseEnter={() => setHoverId(`${item?.inboxId}_${item?.sessionId}`)}
            onMouseLeave={() => setHoverId(null)}
          >
            {hoverId === `${item?.inboxId}_${item?.sessionId}` || isChecked(item?.inboxId, item?.sessionId) ? (
              <div className="avatar-sm">
                <Form.Check
                  type="checkbox"
                  checked={isChecked(item?.inboxId, item?.sessionId)}
                  onChange={() => toggleSingle(item?.inboxId, item?.sessionId)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
            ) : (
              <img
                src={item?.icon}
                alt={item?.name}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "100%"
                }}
              />
            )}
            {item?.type === "inbox" ?
              <div>
                <div className="fw-medium">{item?.name}</div>
                <small className="text-muted">
                  {item?.email}
                </small>
              </div>
              :
              <div>
                <div className="fw-medium">{item?.inboxId}</div>
              </div>
            }
          </div>
        </td>
        {!inboxData && (
          <>
            {category !== "visitor" &&
              <td>{item?.chatType === "liveChat" ? "Live Chat" : "Ticket"}</td>
            }
            <td title={item?.lastMessage || "_"}><div className="text-muted">{limitText(item?.lastMessage || "_", 30)}</div></td>
            <td className="text-capitalize">{item?.lastRepliedBy || "_"}</td>
            <td>
              {item?.lastReplaiedDT ?
                <Moment format="DD MMM YYYY | HH:mm" withTitle>
                  {item?.lastReplaiedDT}
                </Moment>
                : "_"}
            </td>
            <td>{item?.totalMessage || 0}</td>
            <td>{item?.totalNotification || 0}</td>
            <td>{item?.agentName || "_"}</td>
            {category !== "visitor" &&
              <td>
                <span
                  className={`text-capitalize badge ${item?.priority === "high"
                    ? "bg-danger"
                    : item?.priority === "medium" ?
                      "bg-warning" : "bg-success"
                    }`}
                >
                  {item?.priority || ""}
                </span>
              </td>
            }
            <td>{item?.chatStatus === "closed" ? formatDuration(item?.startedDT, item?.endedDT) : liveDuration}</td>
            <td>
              <Badge
                pill
                bg="transparent"
                className={`tag-pill text-capitalize text-${item?.chatStatus === "browsing" ? "warning" : item?.chatStatus === "open" ? "danger" : "success"}`}
                style={{
                  border: `1px solid var(--${item?.chatStatus === "browsing" ? "warning" : item?.chatStatus === "open" ? "danger" : "success"})`,
                }}
              >
                {item?.chatStatus}
              </Badge>
            </td>
            <td>
              <Badge
                pill
                bg="transparent"
                className={`tag-pill text-capitalize text-${item?.sessionStatus === "open" ? "danger" : "success"}`}
                style={{
                  border: `1px solid var(--${item?.sessionStatus === "browsing" ? "warning" : item?.sessionStatus === "open" ? "danger" : "success"})`,
                }}
              >
                {item?.sessionStatus}
              </Badge>
            </td>
            <td>
              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                {inboxType === "deleted" ? item?.deletedDT : item?.updatedAt}
              </Moment>
            </td>
          </>
        )}
      </tr>
    );
  };

  return (
    <div className="w-100" style={{ height: "calc(100vh - 57px)" }}>
      <ToolBar
        search={search}
        deleteData={() => inboxType === "deleted" ? deleteInbox() : softDeleteRestoreInbox("delete")}
        restoreData={inboxType === "deleted" ? (() => softDeleteRestoreInbox("restore")) : false}
        setSearch={setSearch}
        checkedIds={inboxIds}
        setCheckedIds={setInboxIds}
        showPreview={showPreview}
        setShowPreview={() => { setShowPreview(""); }}
        setSelected={setInboxData}
        start={start}
        end={end}
        totalItems={inboxCount}
        page={pageNumber}
        setPage={setPageNumber}
        pageSize={itemsPerPage}
        setPageSize={setItemsPerPage}
        totalPages={totalPages}
        selectInboxType={category === "inbox"}
        setInboxType={setInboxType}
        inboxType={inboxType}
      />
      <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
        <div
          className={`table-section overflow-auto bg-white ${showPreview ? "border-end" : ""
            }`}
          style={{ height: "calc(100vh - 108px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>{category === "visitor" ? "Visitor" : "Contact"}</div>
                  </div>
                </th>
                {!inboxData && (
                  <>
                    {category !== "visitor" &&
                      <th>Type</th>
                    }
                    <th>Last Message</th>
                    <th>Last Replied By</th>
                    <th>Last Replied DT</th>
                    <th>Messages</th>
                    <th>Notifications</th>
                    <th>Agent</th>
                    {category !== "visitor" &&
                      <th>Preority</th>
                    }
                    <th>Duration</th>
                    <th>Status</th>
                    <th>Session</th>
                    <th>{inboxType === "deleted" ? "Deleted DT" : "Updated DT"}</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {inboxs.map((item, index) => (
                <InboxRow
                  key={item?.inboxId || index}
                  item={item}
                />
              ))}
            </tbody>
          </Table>
        </div>
        <div className={`preview-section ${showPreview ? "open" : ""}`}>
          {inboxData &&
            <InboxDetails
              inboxId={inboxId}
              sessionId={sessionId}
              setSessionId={setSessionId}
              currentUserData={currentUserData}
              setInboxData={setInboxData}
              inboxData={inboxData}
              deleteSession={deleteSession}
              category={category}
              setInboxs={setInboxs}
            />}
        </div>
      </div>
    </div>
  );
};

export default InboxData;
